// import React, { useState, useEffect } from 'react';
// import PropTypes from 'prop-types';
// import Plot from 'react-plotly.js';
// import { ManRadioButtonGroup, ManRadioButton, ManText } from '@craft-design-system/core-components-react';
// import useGraphRadio from '../../utils/useGraphRadio';
// import Shimmer_graph from '../shimmer_graph';
// import ifav from './ifav.png';
// import { Button, Popover, OverlayTrigger, Modal } from 'react-bootstrap';
// import { CustomTextDisplay } from '../AI';
// import { useFilterContext } from '../FilterContext';
// import AverageDisplay from '../ride_analysis_kpi/Average_value';
// import DownloadIcon from '@mui/icons-material/Download';
// import { IconButton } from '@mui/material';

// const Battery_temp = ({ value }) => {
//   const [battery_temp, set_battery_temp] = useState(null);
//   const radio_query = useGraphRadio();
//   const [radio_buttons_test, set_Radio_values] = useState(null);
//   const { filterdata } = useFilterContext();
//   const { startDate, endDate } = filterdata || {};
//   const [isLoading, setIsLoading] = useState(false);
//   // const [showMonthlyText, setShowMonthlyText] = useState(value.battery_temp[1]['batterytemp_avg']);
//   const [avg_value, setavg_value] = useState(value.battery_temp[2]['average']);
//   const [downloadData, setDownloadData] = useState(JSON.parse(value.battery_temp[3]));
//   const [showModal, setShowModal] = useState(false); // ✅ Modal state

//   const unit = '°C';

//   const popover = (
//     <Popover id="popover-basic">
//       <Popover.Body>
//         The battery system temperature is displayed by three values: maximum value per day, average value per day and minimum value per day.
//         <br />
//         If more than one vehicle is selected average values are displayed.
//       </Popover.Body>
//     </Popover>
//   );

//   const handleSelectChange1 = (event) => {
//     set_Radio_values((prevValues) => ({
//       ...prevValues,
//       [event.detail.name]: event.detail.value,
//     }));
//   };

//   const handleDownloadClick = () => {
//     if (!Array.isArray(downloadData) || downloadData.length === 0 || !downloadData[0] || Object.keys(downloadData[0]).length === 0) {
//       setShowModal(true);
//       return;
//     }

//     const csvContent = convertToCSV(downloadData);
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = URL.createObjectURL(blob);

//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', 'battery_temperature_data.csv');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const convertToCSV = (data) => {
//     const headers = Object.keys(data[0]).join(',');
//     const rows = data.map(row => Object.values(row).join(','));
//     return [headers, ...rows].join('\n');
//   };

//   useEffect(() => {
//     if (radio_buttons_test) {
//       setIsLoading(true);

//       //console.log(value.vin_short)
//       radio_query({vins_short:[value.vin_short],radio_value:radio_buttons_test,columnname:'Battery_temperature',startDate:startDate,endDate:endDate}).then(data => {
//         set_battery_temp(JSON.parse(data['jsonData'][0]));
//         // setShowMonthlyText(data['jsonData'][1]['batterytemp_avg']);
//         setavg_value(data['jsonData'][2]['average']);
//         setDownloadData(JSON.parse(data['jsonData'][3]));
//         setIsLoading(false);
//       });
//     }
//   }, [radio_buttons_test]);

//   useEffect(() => {
//     try {
//       if (value.battery_temp[0]) {
//         set_battery_temp(JSON.parse(value.battery_temp[0]));
//       }
//       if (value.battery_temp[3]) {
//         setDownloadData(JSON.parse(value.battery_temp[3]));
//       }
//     } catch (error) {
//       console.error("Error parsing JSON", error);
//     }
//   }, [value]);

//   return (
//     <div>
//       <div className="card-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <div style={{ flex: 1, textAlign: 'center' }}>
//           <ManText className="card-title-text" variant="component-l" as="span" size="l">
//           Battery temperature (system) 
//           </ManText>
//         </div>
//         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//           <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
//             <img className="man-logovv1" src={ifav} alt="info" />
//           </OverlayTrigger>
//           <div style={{ transform: 'translateY(-20px)' }}>
//             <IconButton onClick={handleDownloadClick} style={{ color: 'black' }}>
//               <DownloadIcon />
//             </IconButton>
//           </div>
//         </div>
//       </div>

//       <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px', marginTop: '1px' }}>
//         <div style={{ flexShrink: 0 }}>
//           <AverageDisplay averages={avg_value} unit="°C" />
//         </div>
//         <div style={{ flexShrink: 0, marginTop: '6px',transform:'translateY(14px)'}}>
//           <ManRadioButtonGroup
//             name="Battery_temp"
//             invalid="false"
//             onManChange={handleSelectChange1}
//           >
//             <ManRadioButton name="Battery_temp" label="Daily" value="Daily" checked />
//             <ManRadioButton name="Battery_temp" label="Monthly" value="Monthly" />
//             <ManRadioButton name="Battery_temp" label="Yearly" value="Yearly" />
//           </ManRadioButtonGroup>
//         </div>
//       </div>

//       {isLoading ? (
//         <Shimmer_graph />
//       ) : (
//         battery_temp && (
//           <>
//             <Plot
//               data={battery_temp.data}
//               layout={{
//                 ...battery_temp.layout,
//                 margin: { t: 10, r: 10, l: 10, b: 170 }
//               }}
//               useResizeHandler={true}
//             />
//             {/* <CustomTextDisplay
//               value={showMonthlyText}
//               isValueStyled
//             /> */}
//           </>
//         )
//       )}

//       {/* Modal for no data */}
//       <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Download Unavailable</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>Data is not available for download at the moment.</Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// Battery_temp.propTypes = {
//   value: PropTypes.shape({
//     vin_short: PropTypes.string.isRequired,
//     battery_temp: PropTypes.array.isRequired,
//   }).isRequired,
// };

// export default Battery_temp;

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { ManRadioButtonGroup, ManRadioButton, ManText } from '@craft-design-system/core-components-react';
import useGraphRadio from '../../utils/useGraphRadio';
import useSegmentedChartQuery from '../../utils/useSegmentedChartQuery';
import Shimmer_graph from '../shimmer_graph';
import ifav from './ifav.png';
import { Button, Popover, OverlayTrigger, Modal } from 'react-bootstrap';
import AverageDisplay from '../ride_analysis_kpi/Average_value';
import DownloadIcon from '@mui/icons-material/Download';
import { IconButton } from '@mui/material';
import SegmentedControl from '../ride_analysis_kpi/SegmentedControl';
import { useFilterContext } from '../FilterContext';
import DownloadButtonComponent from '../DownloadButtonComponent';
import Zoom from '../Zoom';

const Battery_temp = ({ value }) => {
  const [battery_temp, set_battery_temp] = useState(null);
  const [downloadData, setDownloadData] = useState([]);
  const [radio_buttons_test, set_Radio_values] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [avg_value, setavg_value] = useState(value.battery_temp[2]['average']);
  const [chartType, setChartType] = useState('Bar');

  const { filterdata } = useFilterContext();
  const { startDate, endDate } = filterdata || {};
  const radio_query = useGraphRadio();
  const { fetchSegmentedChart } = useSegmentedChartQuery();

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <strong>Definition:</strong><br />
        This KPI displays the <strong>battery temperature</strong> in which the vehicle is operating.
        <br /><br />
        <strong>Telematic raw data for this KPI:</strong><br />
        TBM3: payloaddecoded_batterytemperature_value<br />
        CM4: payload_electricmessagesystem_batterytemperature
        <br /><br />
        <strong>Time series data:</strong><br />
        If multiple vehicles are selected, average values are displayed. Days without data are not taken into account for the calculation.
        <br /><br />
        <strong>Histogram:</strong><br />
        Each bar represents the number of days that fall within a certain range (bin) of daily average battery temperature values. All daily values since start of data acquisition for the selected vehicle(s) are visualized by default.
        <br /><br />
        <strong>Boxplot:</strong><br />
        The boxplot shows the distribution of daily average battery temperature values for the selected vehicle(s) since start of data acquisition. If multiple vehicles are selected, the boxplot reflects the combined distribution of all their daily values.
        <br /><br />
        • The box represents the middle 50% of values (from the 25th percentile ("q1") to the 75th percentile ("q3")).<br />
        • The line inside the box shows the median (50th percentile).<br />
        • The whiskers extend to show the range of typical values ("min" and "max") and visualize the spread of the data beyond the central box.
      </Popover.Body>
    </Popover>
  );

  const handleSelectChange1 = (event) => {
    set_Radio_values((prevValues) => ({
      ...prevValues,
      [event.detail.name]: event.detail.value,
    }));
  };

  const handleDownloadClick = () => {
    if (!Array.isArray(downloadData) || downloadData.length === 0) {
      setShowModal(true);
      return;
    }
    const csvContent = convertToCSV(downloadData);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `battery_temperature_${chartType.toLowerCase()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const convertToCSV = (data) => {
    const headers = Object.keys(data[0]).join(',');
    const rows = data.map(row => Object.values(row).join(','));
    return [headers, ...rows].join('\n');
  };

  // 🔹 Fetch segmented chart (Bar / Histogram / Boxplot)
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const data = await fetchSegmentedChart({
          vinShort: value.vin_short,
          chartType,
          columnname: 'Battery_temperature',
        });

        if (chartType === 'Bar') {
          set_battery_temp(JSON.parse(data[0]));
          setDownloadData(JSON.parse(data[2]));
        } else {
          set_battery_temp(JSON.parse(data[0]));
          setDownloadData(JSON.parse(data[1]));
        }
      } catch (error) {
        console.error('Error fetching chart data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (!isInitialLoad && chartType && value?.vin_short) {
      fetchData();
    } else {
      setIsInitialLoad(false);
    }
  }, [chartType]);

  // 🔹 Radio button daily/monthly/yearly
  useEffect(() => {
    if (radio_buttons_test) {
      setIsLoading(true);
      radio_query({
        vins_short: [value.vin_short],
        radio_value: radio_buttons_test,
        columnname: 'Battery_temperature',
        startDate,
        endDate,
      }).then(data => {
        set_battery_temp(JSON.parse(data['jsonData'][0]));
        setavg_value(data['jsonData'][2]['average']);
        setDownloadData(JSON.parse(data['jsonData'][3]));
        setIsLoading(false);
      });
    }
  }, [radio_buttons_test, chartType]);

  // 🔹 Initial data setup
  useEffect(() => {
    try {
      set_battery_temp(JSON.parse(value.battery_temp[0]));
      if (value.battery_temp[3]) {
        setDownloadData(JSON.parse(value.battery_temp[3]));
      }
    } catch (error) {
      console.error('Error parsing JSON', error);
    }
  }, [value]);

  return (
    
    <div style={{ padding: '16px' }}>
    {/* Title + Info */}
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px',
      gap: '8px'
    }}>
      <div style={{
        flex: 1,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '100px'
      }}>
        <ManText
          className="card-title-text"
          variant="component-l"
          as="span"
          size="l"
          style={{ lineHeight: 'normal' }}
        >
         Battery temperature (system)
        </ManText>
      </div>
      <div style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        flexDirection: "row-reverse"
        // margingtop: 30
      }}>
        {/* <PopoverComponent
          id="charging_time"
          content={tooltipContent}
        /> */}
        <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
          <img className="man-logovv1" src={ifav} alt="info" />
        </OverlayTrigger>
        <Zoom
          chartData={battery_temp?.data}
          chartLayout={battery_temp?.layout}
          chartTitle="Battery temperature (system)"
        />
        <DownloadButtonComponent
          data={downloadData}
          fileName={`battery_temp_${chartType.toLowerCase()}_${radio_buttons_test?.["Battery temperature"]?.toLowerCase() || "daily"}.xlsx`}
        />
      </div>
    </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <div style={{ flexShrink: 0 }}>
          <AverageDisplay averages={avg_value} unit="°C" />
        </div>

        <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
          <ManRadioButtonGroup
            name="Battery_temp"
            invalid="false"
            onManChange={handleSelectChange1}
            style={{ display: 'flex', gap: '20px' }}
          >
            <ManRadioButton name="Battery_temp" label="Daily" value="Daily" checked />
            <ManRadioButton name="Battery_temp" label="Monthly" value="Monthly" />
            <ManRadioButton name="Battery_temp" label="Yearly" value="Yearly" />
          </ManRadioButtonGroup>
        </div>

        <div style={{ marginLeft: 'auto' }}>
          <SegmentedControl
            selected={chartType}
            onChange={(type) => setChartType(type)}
            options={['Bar', 'Histogram', 'Boxplot']}
          />
        </div>
      </div>

      <div style={{ 
          flexGrow: 1, 
          minHeight: 0,        // ✅ Added to prevent flex overflow
          overflow: 'hidden'   // ✅ Added to contain the chart
        }}>
          {isLoading ? (
            <Shimmer_graph />
          ) : (
            battery_temp && (
              <Plot
                data={battery_temp.data}
                layout={{
                  ...battery_temp.layout,
                  autosize: true,
                  margin: { t: 10, r: 10, l: 10, b: 160 },
                  xaxis: { ...battery_temp.layout?.xaxis, rangeslider: { visible: false } },
                }}
                style={{ 
                  width: '100%', 
                  height: '100%'     // ✅ Fill the container completely
                }}
                useResizeHandler={true}
                config={{
                  responsive: true,
                  displayModeBar: false
                }}
              />
            )
          )}
        </div>

      {/* Modal for No Data */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Download Unavailable</Modal.Title>
        </Modal.Header>
        <Modal.Body>Data is not available for download at the moment.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

Battery_temp.propTypes = {
  value: PropTypes.shape({
    vin_short: PropTypes.string.isRequired,
    battery_temp: PropTypes.array.isRequired,
  }).isRequired,
};

export default Battery_temp;

